<template>
  <div class="overall-bg header-top">
    <b-container class="">
      <div class="form-white-bg">
        <b-container>
          <b-row>
            <b-col>
              <BacktoPage
                :goback="$router.back"
                v-if="Number(QueryStringValue?.IsApproval) !== 1"
              ></BacktoPage>
            </b-col>
          </b-row>
          <b-row v-if="loading" class="pt-3">
            <b-col sm="6" cols="12">
              <Skeleton width="12rem" />
            </b-col>
            <b-col sm="6" cols="12">
              <Skeleton height="2rem" width="7rem" class="float-end" />
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col xl="6" md="6" sm="6" cols="12" class="pt-5">
              <p class="light-txt">{{ SummaryName }} Summary</p>
            </b-col>
            <b-col xl="6" md="6" sm="6" cols="12" class="pt-5">
              <div class="float-end d-flex align-items-center gap-3">
                <div
                  class="d-flex align-items-center gap-3 flex-column"
                  v-if="Number(QueryStringValue?.IsApproval) !== 1"
                >
                  <RedStatus
                    name="PO Amendment Cancelled"
                    v-if="details.Postatus == 5 && details.IsApproved == 0"
                  />
                  <RedStatus
                    name="PO Cancelled"
                    v-if="details.Postatus == 4 && details.IsApproved == 1"
                  />

                  <div
                    class="d-flex align-items-center gap-1"
                    v-if="details.Postatus == 4 && details.IsApproved == 1"
                  >
                    <lable>Cancelled Reason:</lable>
                    <p>{{ details.CancelReason }}</p>
                  </div>

                  <AddButton
                    btnname="Revert"
                    v-if="details.Postatus == 4 && details.IsApproved == 1"
                    @click="RevertPO"
                  />

                  <Button
                    v-if="
                      details.Postatus != 5 &&
                      details.Postatus != 4 &&
                      details.Postatus != 1
                    "
                    class="printbtn Actionsbtn p-button-sm"
                    label="Actions"
                    severity="info"
                    @click="toggle"
                    aria-haspopup="true"
                    icon="pi pi-angle-down"
                    aria-controls="overlay_menu"
                    iconPos="right"
                    size="small"
                  />
                  <Menu
                    ref="menu"
                    id="overlay_menu"
                    :model="items"
                    :popup="true"
                  />
                </div>
                <div>
                  <Button
                    label="Print"
                    severity="success"
                    icon="pi pi-print"
                    class="printbtn ms-2"
                    @click="Print"
                  />
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
        <b-row v-if="loading" class="pt-3">
          <b-row>
            <b-col xl="4" lg="3" sm="4" md="6" cols="12">
              <MobileLoader />
            </b-col>
          </b-row>
        </b-row>
        <b-row class="px-3" v-else>
          <b-col lg="4" xl="4" xxl="4" md="8" sm="8">
            <Card class="summarycard">
              <template #title>
                <b-row>
                  <b-col cols="8">
                    <p class="card-font">{{ details.Po }}</p>
                    <p class="card-font">
                      <span
                        ><i class="pi pi-calendar"></i
                        >{{ details.Podate }}</span
                      >
                    </p>
                  </b-col>
                  <b-col cols="4" class="d-flex flex-row-reverse card-font">
                    <p>₹ {{ details.Price }}</p>
                  </b-col>
                </b-row>
              </template>
              <template #content>
                <b-row class="mb-2 mt-3">
                  <b-col>
                    <h6>Supplier Information</h6>
                    <div class="d-flex">
                      <p class="light-txt me-3">Name:</p>
                      <p>
                        {{ details.SupplierName }}
                      </p>
                    </div>
                    <div class="d-flex my-2">
                      <p class="light-txt me-3">Address:</p>
                      <p>
                        {{ details.SupplierAddress ?? details.Address }}
                      </p>
                    </div>

                    <div class="d-flex my-2">
                      <p class="light-txt me-3">GST:</p>
                      <p>
                        {{ details.GST }}
                      </p>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <h6 class="fn14">Payment Terms</h6>
                    <p class="termstxt">
                      {{ removeHtmlTags(details.Paymentterms) }}
                    </p>
                  </b-col>
                  <b-col>
                    <h6 class="fn14">Delivery Terms</h6>
                    <p class="termstxt">
                      {{ removeHtmlTags(details.deliveryterms) }}
                    </p>
                  </b-col>
                </b-row>
              </template>
            </Card>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <div class="overall-bg p-0 header-top">
      <section>
        <b-container class="storetabdetails">
          <TabView class="tabview-custom" ref="tabview4" :scrollable="true">
            <!-- scrollable @keyup.enter="handleKeyDown"> -->
            <TabPanel v-for="(tab, index) in TabArray" :key="index">
              <template #header>
                <div @click="TabClick(tab, index)">
                  <i
                    class="pi pi-align-left pe-3"
                    :class="tab['ListLength'] > 0 ? '' : 'withoutbadge'"
                  ></i>
                  <span :class="tab['ListLength'] > 0 ? '' : 'withoutbadge'"
                    >{{ $t(`${tab["Path"]}`) }}
                    <Badge
                      :value="tab['ListLength']"
                      severity="warning"
                      v-if="tab['ListLength'] > 0"
                    ></Badge>
                  </span>
                </div>
              </template>
              <div v-if="tab['EntityId'] == 3134">
                <PODetailsItemMapping
                  @additem="AddItems"
                  :QueryValue="QueryStringValue"
                />
              </div>
              <div v-else>
                <MasterEmpty
                  v-if="tab['ListLength'] === 0"
                  :eheader="tab['SubMenuName']"
                  :econtent="tab['SubMenuName']"
                  eimg="/src/assets/Img/icons/supplier-mapping.svg"
                  :createline="false"
                />
                <Tableview
                  v-if="tab['ListLength'] !== 0"
                  :value="tab['List']"
                  :paginator="true"
                  class="p-datatable-gridlines"
                  :rows="10"
                  :rowHover="true"
                  filterDisplay="menu"
                  :loading="loading1"
                  :filters="tab['filters']"
                  responsiveLayout="scroll"
                  :columns="tab['headers']"
                  :globalFilterFields="tab['globalFilterFields']"
                  selectionMode="single"
                  :serialNumber="true"
                  @row-click="(event) => RowClick(event, tab['EntityId'])"
                >
                  <template v-slot:PaymentStatus="{ data }">
                    <div v-if="data.DocType == 19">-</div>
                    <template v-else>
                      <OrangeStatus
                        name="Pending"
                        v-if="data.IsDraft != 1 && data.PaymentFlag == '2'"
                      />
                      <BlueStatus
                        name="Partially Paid"
                        v-if="data.IsDraft != 1 && data.PaymentFlag == '3'"
                      />
                      <GreenStatus
                        name="Paid"
                        v-if="data.IsDraft != 1 && data.PaymentFlag == '1'"
                      />
                      <RedStatus
                        name="OverDue"
                        v-if="data.IsDraft != 1 && data.PaymentFlag == '4'"
                      />
                      <div
                        v-if="
                          data.IsDraft != 1 &&
                          (data.PaymentFlag == '2' || data.PaymentFlag == '4')
                        "
                      >
                        <span>
                          Pending Since:{{
                            data.PendingDays == 0
                              ? "Today"
                              : data.PendingDays + " Days"
                          }}
                        </span>
                      </div>
                    </template>
                  </template>
                  <template v-slot:IsApproved="{ data }">
                    <div style="text-align: center">
                      <OrangeStatus
                        name="Pending"
                        v-if="data.IsApproved == '0'"
                      />
                      <GreenStatus
                        name="Approved"
                        v-if="data.IsApproved == '1'"
                      />
                    </div>
                  </template>
                  <!-- GRN   -->

                  <!-- GRN Return   -->
                  <template v-slot:Status="{ data }">
                    <span>
                      <RedStatus name="Draft" v-if="data.IsDraft == '1'" />
                      <OrangeStatus
                        name="Pending"
                        v-if="
                          data.GRNReturnStatus == '0' && data.IsDraft != '1'
                        "
                      />
                      <BlueStatus
                        name="Partial"
                        v-if="
                          data.GRNReturnStatus == '1' && data.IsDraft != '1'
                        "
                      />
                      <GreenStatus
                        name="Completed"
                        v-if="
                          data.GRNReturnStatus == '2' && data.IsDraft != '1'
                        "
                      />
                    </span>
                  </template>
                  <!-- GRN  Return -->

                  <!-- paymentTerms   -->
                  <template v-slot:ApprovalStatus="{ data }">
                    <div style="text-align: center">
                      <OrangeStatus
                        name="Pending"
                        v-if="data.IsApproved == '0' && data.Initiate == true"
                      />
                      <GreenStatus
                        name="Approved"
                        v-if="data.IsApproved == '1' && data.Initiate == true"
                      />
                      <BlueStatus
                        name="Awaiting"
                        v-if="data.IsApproved == '2' && data.Initiate == true"
                      />
                      <RedStatus
                        name="Declined"
                        v-if="data.IsApproved == '3' && data.Initiate == true"
                      />
                      <span
                        v-if="
                          !(
                            data.IsApproved == '0' ||
                            data.IsApproved == '1' ||
                            data.IsApproved == '3' ||
                            data.IsApproved == '2'
                          ) || !data.Initiate
                        "
                        >-</span
                      >
                    </div>
                  </template>
                  <template v-slot:Percentage="{ data }">
                    <div>
                      <template v-if="!data.EditFlag">
                        {{ data.Percentage }}
                      </template>
                      <template v-else>
                        <div class="label-d-none tablefield mb-0">
                          <!-- <input type="text" v-model="data.Percentage" class="percentage-input" style="width: 100px"
                          @input="validatePercentage(data.Percentage, data.Id, index)" /> -->
                          <TextField
                            :name="`Percentage${data.Id}`"
                            :rules="{
                              required: false,
                              nonnegative: true,
                              decimal: true,
                              percentage: true,
                            }"
                            :id="`Percentage${data.Id}`"
                            v-model="data.Percentage"
                            @keyup="
                              validatePercentage(
                                data.Percentage,
                                data.Id,
                                index
                              )
                            "
                          />
                        </div>
                      </template>
                    </div>
                  </template>
                  <template v-slot:Amount="{ data }">
                    <div>
                      <template v-if="!data.EditFlag">
                        {{ data.Amount }}
                      </template>
                      <template v-else>
                        <div class="label-d-none tablefield mb-0">
                          <TextField
                            :name="`Amount${data.Id}`"
                            :rules="{
                              required: false,
                              nonnegative: true,
                              decimal: true,
                            }"
                            :id="`Amount${data.Id}`"
                            v-model="data.Amount"
                            @keyup="validateAmount(data.Amount, data.Id, index)"
                          />
                        </div>
                      </template>
                    </div>
                  </template>

                  <template v-slot:Action="{ data }">
                    <div v-if="data.EditFlag">
                      <i
                        class="pi pi-check"
                        title="Update"
                        @click.stop="UpdatePayment(data, index)"
                      ></i>
                      <i
                        class="pi pi-undo ms-2"
                        title="Undo"
                        @click.stop="UndoPayment(data, index)"
                      ></i>
                    </div>

                    <div v-else>
                      <i
                        v-if="
                          data.POApprovalStatus == 1 &&
                          (data.Status == '0' || data.Status == '1') &&
                          (!data.Initiate ||
                            (data.Initiate &&
                              Number(QueryStringValue?.IsApproval) === 1 &&
                              !data.IsApproved)) &&
                          data.POIntitateStatus == 1 &&
                          details.IsDraft == 0
                        "
                        class="pi pi-pencil"
                        style="color: #3096ff"
                        @click.stop="EditPayment(data, index)"
                      ></i>

                      <i
                        v-if="
                          data.Initiate &&
                          Number(QueryStringValue?.IsApproval) !== 1
                        "
                        class="pi pi-eye eyeicon"
                        title="View Details"
                        @click="ViewDetails(data, tab['EntityId'])"
                      ></i>
                    </div>
                  </template>

                  <template v-slot:StatusSlot="{ data }">
                    <div style="text-align: center" v-if="details.IsDraft == 0">
                      <OrangeStatus
                        name="Payment Pending"
                        v-if="data.Status == '0'"
                      />

                      <template v-if="data.Status == '1'">
                        <GreenStatus name="Partially Paid" />
                        <div>{{ data.ModifiedAtHr }}</div>
                      </template>

                      <template v-if="data.Status == '2'">
                        <GreenStatus name="Paid" />
                        <div>{{ data.ModifiedAtHr }}</div>
                      </template>
                    </div>
                    <div v-else>{{ "-" }}</div>
                  </template>
                  <template v-slot:Upload="{ data }">
                    <!--  Not Initiated -->
                    <div
                      v-if="
                        buttondisable == false &&
                        data.Initiate == false &&
                        data.POApprovalStatus == 1 &&
                        details.IsDraft == 0
                      "
                      class="field"
                    >
                      <input
                        type="file"
                        :multiple="true"
                        :id="'actual-btn' + `${data.Id}`"
                        @click.stop
                        @change.stop="
                          (event) => handleChangedocument(event, data)
                        "
                        ref="fileInput"
                        style="display: none"
                      />
                      <label
                        id="custom-btn"
                        :for="'actual-btn' + `${data.Id}`"
                        class="upload-button"
                        @click.stop
                      >
                        <i
                          class="pi pi-upload"
                          style="margin-right: 8px"
                          @click.stop
                        ></i>
                        Upload File</label
                      >
                    </div>
                    <!-- Initiated -->
                    <div v-else>
                      <div
                        v-if="
                          data.POApprovalStatus == 1 && details.IsDraft == 0
                        "
                      >
                        <GreenStatus
                          name=" Uploaded"
                          v-if="
                            uploadedTableList.some(
                              (entry) => entry.uploadId == data.Id
                            )
                          "
                          @click.stop
                        />
                        <OrangeStatus name="No File" @click.stop v-else />
                      </div>
                      <div v-else>
                        {{ "-" }}
                      </div>
                    </div>
                  </template>
                  <template v-slot:View="{ data }">
                    <div
                      v-for="(item, index) in uploadedTableList"
                      :key="index"
                    >
                      <div
                        v-if="
                          uploadedTableList.length > 0
                            ? item.uploadId == data.Id
                            : ''
                        "
                        :title="item.fileName"
                        class="d-flex align-items-center"
                      >
                        <div>
                          <p class="filenametxt">{{ item.fileName }}</p>
                          <div
                            class="blue-txt"
                            id="file-name"
                            @click.stop="fileviewer(item.fullPath)"
                          >
                            View
                          </div>
                        </div>
                        <DeleteIcon
                          v-if="data.Initiate == false"
                          @click.stop="fileuploadDelete(item)"
                        />
                      </div>
                    </div>
                  </template>

                  <template v-slot:Initiate="{ data }">
                    <div class="action-container">
                      <button
                        v-if="
                          data.Initiate == false &&
                          buttondisable == false &&
                          data.POApprovalStatus != 0 &&
                          data.POIntitateStatus == 1 &&
                          details.IsDraft == 0
                        "
                        class="initiate-button"
                        @click="InitiateOnClick(data.Id, data.Reason)"
                      >
                        <i class="pi pi-bolt" style="margin-right: 6px"></i>
                        Initiate
                      </button>
                      <span
                        v-else-if="
                          data.Initiate == false &&
                          buttondisable == false &&
                          data.POApprovalStatus != 0 &&
                          data.POIntitateStatus == 0
                        "
                        >-</span
                      >
                      <button
                        v-else-if="
                          data.IsApproved == 3 &&
                          buttondisable == false &&
                          data.POApprovalStatus != 0
                        "
                        class="initiate-button"
                        @click="InitiateOnClick(data.Id, data.Reason)"
                      >
                        <i class="pi pi-bolt" style="margin-right: 6px"></i>
                        ReInitiate
                      </button>
                      <GreenStatus
                        v-else-if="
                          data.Initiate == true &&
                          data.IsApproved != 3 &&
                          data.POApprovalStatus != 0
                        "
                        name="Initiated"
                      />
                      <OrangeStatus
                        v-else-if="
                          buttondisable == true &&
                          data.Initiate == false &&
                          data.POApprovalStatus != 0
                        "
                        name="Not Initiated"
                      />
                      <OrangeStatus
                        v-else-if="data.POApprovalStatus == 0"
                        name="PO approval pending"
                      />
                    </div>
                  </template>

                  <template v-slot:ReasonSlot="{ data, Index }">
                    <div
                      class="label-d-none tablefield mb-0"
                      v-if="
                        data.Initiate == false &&
                        data.POIntitateStatus == 1 &&
                        data.POApprovalStatus != 0 &&
                        details.IsDraft == 0
                      "
                    >
                      <!-- {{ data.Reason }} -->
                      <InputText
                        type="text"
                        placeholder=""
                        clearable
                        :name="`'Reason'${data.index}`"
                        :id="`'Reason'${data.index}`"
                        label=""
                        v-model="data.Reason"
                        :rules="{ required: false, numeric: true }"
                        :requiredIcon="false"
                      />
                    </div>
                    <div v-else-if="data.Initiate == true">
                      {{ data.Reason }}
                    </div>
                  </template>
                </Tableview>
              </div>
            </TabPanel>
          </TabView>
        </b-container>
      </section>
    </div>
  </div>

  <Dialog
    v-model:visible="ObjCancelPopUp.CancelReasonPopup"
    modal
    :header="ObjCancelPopUp.PopUpHeaderName"
    :breakpoints="{
      '1980px': '55vw',
      '1440px': '60vw',
      '960px': '70vw',
      '640px': '90vw',
    }"
    class="overall-bg"
  >
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="field">
            <Textarea
              :name="ObjCancelPopUp.TextAareaName"
              :label="ObjCancelPopUp.TextAareaName"
              :rules="{ required: false }"
              :id="ObjCancelPopUp.TextAareaName"
              v-model="ObjCancelPopUp.CancelReason"
            />
            <Footer
              class="p-3"
              @cancel="ObjCancelPopUp.CancelReasonPopup = false"
              @save="SaveCancelPO"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </Dialog>

  <CrystalReportPrintPopUp
    :ShowAndHide="CrystalReportPopup"
    :ParameterValues="ParameterValues"
    :PrintType="PrintType"
    @closepopup="hidepopup"
  />

  <CancelSuccessfully
    :content="ModelPopupDunction.CancelModelTxt"
    :visible="ModelPopupDunction.Cancelpop"
    @ok="cancelclose()"
  />
  <RevertedSuccessfully
    :content="ModelPopupDunction.RevertModelTxt"
    :visible="ModelPopupDunction.Revertpop"
    @ok="cancelclose()"
  />
  <CancelConfirmation
    :Editmodel="ModelPopupDunction.cancelmodel"
    @yes="Statuschange()"
    @no="ModelPopupDunction.cancelmodel = false"
    :header="ObjCancelPopUp.ConfirmPopupHeader"
    :content="ObjCancelPopUp.ConfirmPopupContent"
  />
  <Toast />
  <Sidebar
    v-model:visible="grnvisible"
    :style="{ width: '75%' }"
    position="right"
  >
    <template #header>
      <b-row class="w-100">
        <b-col>GRN Details</b-col>
        <b-col
          ><i class="pi pi-times float-end" @click="grnvisible = false"></i>
        </b-col>
      </b-row>
    </template>
    <GRNDetails :Operations="grndata" />
  </Sidebar>
  <Sidebar
    v-model:visible="grnreturnvisible"
    :style="{ width: '75%' }"
    position="right"
  >
    <template #header>
      <b-row class="w-100">
        <b-col>GRN Return Details</b-col>
        <b-col
          ><i
            class="pi pi-times float-end"
            @click="grnreturnvisible = false"
          ></i>
        </b-col>
      </b-row>
    </template>
    <GRNReturnDetails :Operations="grnreturndata" />
  </Sidebar>
  <Sidebar
    v-model:visible="POAvisible"
    :style="{ width: '75%' }"
    position="right"
  >
    <template #header>
      <b-row class="w-100">
        <b-col>PO Details</b-col>
        <b-col
          ><i class="pi pi-times float-end" @click="POAvisible = false"></i>
        </b-col>
      </b-row>
    </template>
    <PODetails :Operations="POdata" />
  </Sidebar>
  <Sidebar
    v-model:visible="POPaymentsvisible"
    :style="{ width: '75%' }"
    position="right"
  >
    <template #header>
      <b-row class="w-100">
        <b-col>POPayment Approval Status</b-col>
        <b-col
          ><i
            class="pi pi-times float-end"
            @click="POPaymentsvisible = false"
          ></i>
        </b-col>
      </b-row>
    </template>
    <NormalTable
      :rowHover="true"
      filterDisplay="menu"
      responsiveLayout="scroll"
      :columns="Approvalheaders"
      v-model:value="ApprovalList"
    >
      <template v-slot:ApprovalStatus="{ data }">
        <OrangeStatus
          name="Pending"
          v-if="data.IsApproved == '0' && !isOverdue(data.InitiatedAt)"
        />
        <RedStatus
          name="Pending"
          v-if="data.IsApproved == '0' && isOverdue(data.InitiatedAt)"
        />
        <GreenStatus name="Approved" v-if="data.IsApproved == '1'" />
        <RedStatus name="Declined" v-if="data.IsApproved == '3'" />
      </template>
      <template v-slot:ApprovedBySlot="{ data }">
        <div v-if="data.IsApproved == '0'">-</div>
        <div v-else>
          {{ data.UserName }}
        </div>
      </template>
      <template v-slot:ApprovedAtSlot="{ data }">
        <div v-if="data.IsApproved == '0'">-</div>
        <div v-else>
          {{ data.ApprovedAt }}
        </div>
      </template>
      <template v-slot:RemarksSlot="{ data }">
        <div v-if="data.Remarks == ''">-</div>
        <div v-else>
          {{ data.Remarks }}
        </div>
      </template>
    </NormalTable>
  </Sidebar>
</template>

<script lang="ts">
import { defineComponent, ref, Ref, onMounted, watch, computed } from "vue";
import { parseISO, differenceInHours, parse } from "date-fns";
import LeftBar from "../../../../../modules/Inventory/components/MasterDetails/LeftSideBar.vue";
import Details from "../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import MemberDetails from "../../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";

// import Rightsidebar from '../../../../modules/Inventory/components/Sidebar/RightSidebar/ItemDetailsSidebar.vue'
import UserDetails from "../../../../../modules/Inventory/components/Sidebar/RightSidebar/UserDetailsRightSidebar.vue";
import Log from "../../../../../modules/Inventory/components/Sidebar/RightSidebar/UserDetailsRightSidebar.vue";
import BacktoPage from "../../../../../components/FormComponents/BacktoMaster.vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import POTableview from "../../../../../modules/Inventory/pages/Transaction/PurchaseOrder/POTable.vue";
import common from "../../../../../modules/Inventory/Service/CommonService";
import commonService from "../../../Service/WithoutStockAffectService";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import CancelConfirmation from "../../../../../components/FormComponents/CancelConfirmation.vue";
import CancelSuccessfully from "../../../../../components/FormComponents/CancelSuccessfully.vue";
import RevertedSuccessfully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import service from "../../../Service/SupplierMaster";
import PoApprovalService from "../../../Service/PoApprovalService";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import Loader from "../../../../../components/FormComponents/Loader.vue";
import PODetailsItemMapping from "../../../../../modules/Inventory/components/MasterDetails/TabsPage/PODetailsItemMapping.vue";
import MobileLoader from "../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ApprovalConfirmation from "../../../../../components/FormComponents/ApprovalConfirmation.vue";
import ApprovalStatus from "../../../../../components/FormComponents/ApprovalStatus.vue";
import moment from "moment";
import supplierService from "../../../../../modules/Inventory/Service/SupplierMaster";
import DeliveryTermsService from "../../../../../modules/Inventory/Service/DeliveryTermsService";
import { useToast } from "primevue/usetoast";
import Textarea from "../../../../../components/FormComponents/TextArea.vue";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import ConfirmPopup from "primevue/confirmpopup";
import { setupHistoryManagement } from "../../../../../modules/Inventory/Service/HistoryManage";
import { useI18n } from "vue-i18n";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import StockInService from "../../../../../modules/Inventory/Service/StockInService";
import StockOutService from "../../../../../modules/Inventory/Service/StockOutService";
import POPaymentTermsService from "../../../../../modules/Inventory/Service/POPaymentTermsDetails";
import GRNDetails from "../../../../../modules/Inventory/pages/Transaction/stockin/grn/GrnTableDetails.vue";
import GRNReturnDetails from "../../../../../modules/Inventory/pages/Transaction/StockOut/GRNReturn.vue";
import MastersService from "../../../../../modules/Inventory/Service/MastersService";
import StockWOFileUploadServices from "../../../../../modules/Inventory/Service/StockWOFileUploadService";
import PODetails from "../../../../../modules/Inventory/pages/Transaction/PurchaseOrder/PODetails.vue";
import NormalTable from "../../../../../components/FormComponents/NormalTable.vue";
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import { checkPermission } from "../../../../../modules/Inventory/Service/AccessControl";
import CrystalReportPrintPopUp from "../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";

export default defineComponent({
  components: {
    CancelSuccessfully,
    CancelConfirmation,
    LeftBar,
    Details,
    MemberDetails,
    UserDetails,
    Log,
    BacktoPage,
    Headerlayout,
    POTableview,
    PODetailsItemMapping,
    Loader,
    MobileLoader,
    ApprovalConfirmation,
    ApprovalStatus,
    Textarea,
    Footer,
    RevertedSuccessfully,
    Tableview,
    GRNDetails,
    GRNReturnDetails,
    POPaymentTermsService,
    PODetails,
    NormalTable,
    MasterEmpty,
    TextField,
    CrystalReportPrintPopUp,
  },

  props: {
    Operations: {
      type: Object,
      default: () => ({}),
    },
    ApprovalObj: {
      type: Object,
      default: () => ({}),
    },
    NotSaveObj: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let buttondisable = ref(false);

    let HospitalId = Number(usersData.OrganizationId);
    let BranchId = Number(usersData.BranchId);

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    const grnvisible = ref(false);
    const grnreturnvisible = ref(false);
    const POAvisible = ref(false);
    const POPaymentsvisible = ref(false);
    const EditFlag = ref(false);

    let List = ref([]);
    const POList = ref([]);
    const GRNList = ref([]);
    const GRNReturnList = ref([]);
    const PaymentList: any = ref([]);
    const POfilters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: { value: null, matchMode: FilterMatchMode.IN, options: List },
      DocDateHR: { value: null, matchMode: FilterMatchMode.IN, options: List },
      Amount: { value: null, matchMode: FilterMatchMode.IN, options: List },
    };

    const grnfilters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      BranchName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      DocDateHR: { value: null, matchMode: FilterMatchMode.IN, options: List },
      DocNo: { value: null, matchMode: FilterMatchMode.IN, options: List },
      SupplierName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      Address: { value: null, matchMode: FilterMatchMode.IN, options: List },
      GSTNO: { value: null, matchMode: FilterMatchMode.IN, options: List },
      PaymentTermsDesc: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      DeliTermsDesc: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      RefNo: { value: null, matchMode: FilterMatchMode.IN, options: List },
      InvoiceNo: { value: null, matchMode: FilterMatchMode.IN, options: List },
      InvoiceDateHR: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemQty: { value: null, matchMode: FilterMatchMode.IN, options: List },
      NetAmount: { value: null, matchMode: FilterMatchMode.IN, options: List },
    };
    const paymentfilters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Description: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      Percentage: { value: null, matchMode: FilterMatchMode.IN, options: List },
      Amount: { value: null, matchMode: FilterMatchMode.IN, options: List },
      TAT: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      Status: { value: null, matchMode: FilterMatchMode.IN, options: List },
      IsApproved: { value: null, matchMode: FilterMatchMode.IN, options: List },
    };

    let DeptRoleMapId = Number(rolesData.DeptRoleMapId);
    let loading1 = ref(false);

    const { t } = useI18n();
    let Id = ref([]);
    const router = useRouter();
    const route = useRoute();
    let fullPath = ref();
    let uploadId = ref();
    let uploadedTableList: any = ref([]);
    let DeletedFileUpload: any = [];
    let IsDraftFlag: any = [];

    const toast = useToast();
    const isActive = ref(false);
    const menu = ref();
    const buttonValue = ref(true);
    const POAmendmentshow = ref(true);

    let loading = ref(false);
    let sidebardata = ref([]);
    const showmodalref = ref(false);
    const activeIndex = ref(0);
    const currentStatus = ref("process");
    let SummaryName = ref("");

    let ApprovalList: any = ref([]);
    let ApprovalListchange = ref([]);
    let itemslist: any = ref([]);

    // Add missing refs for tab counts
    let ObjVal1 = ref({
      arraylenght: 0,
    });

    let ObjVal5 = ref({
      arraylenght: 0,
    });

    let QueryStringValue = ref(route.query);
    watch(
      () => [props.Operations, props.ApprovalObj],
      ([newOperations, newApprovalObj]) => {
        debugger;
        debugger;
        if (newOperations.Id) {
          QueryStringValue.value = newOperations;
          buttondisable.value = true;
        }
        debugger;
        if (newOperations.OriginalId && newApprovalObj.Status) {
          isForm.value.IsApproved = newApprovalObj.Status;
          UpdateApprovalStatus(
            newOperations.OriginalId,
            newApprovalObj.Status,
            newApprovalObj.ApprovalURL
          );
        }
      },
      { immediate: true, deep: true }
    );
    watch(
      () => props.NotSaveObj,
      (newNotSaveObj) => {
        debugger;
        debugger;

        if (newNotSaveObj == true) {
          // Get the current edited data from the TabArray
          if (CopyTableindex.value) {
            const currentTableData = TabArray.value[CopyTableindex.value];
            const editedItemIndex = currentTableData.List.findIndex(
              (item) => item.EditFlag === false
            );
            const copyPaymentItem = CopyPaymentList.value[editedItemIndex];
            TabArray.value[CopyTableindex.value].List = CopyPaymentList.value;
            if (copyPaymentItem && CopyTableindex.value !== undefined) {
              UpdatePayment(copyPaymentItem, CopyTableindex.value);
            }
            CopyPaymentList.value = {};
            emit("CopyPaymentListObj", CopyPaymentList.value);
          }
        }
      },
      { immediate: true }
    );

    const ModelPopupDunction = ref({
      cancelmodel: false,
      CancelModelTxt: "",
      Cancelpop: false,

      Revertmodel: false,
      RevertModelTxt: "",
      Revertpop: false,
    });

    let ObjCancelPopUp = ref({
      CancelReasonPopup: false,
      CancelReason: "",
      PopUpHeaderName: "",
      TextAareaName: "",
      ConfirmPopupHeader: "",
      ConfirmPopupContent: "",
    });

    const ObjCancelPO = ref({
      Id: 0,
      Status: "0",
      Amount: 0.0,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      CreatedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      CancelReason: "",
      IsApproved: 0,
      Type: 0,
      StoreId: 0,
      DocNo: "",
    });

    let details: any = ref({
      SupplierId: 0,
      Price: "",
      Podate: "",
      Paymentterms: "",
      DeliveryTerms: "",
      Po: "",
      RefNo: "",
      SupplierName: "",
      Address: "",
      SupplierAddress: "",
      // suppliername: "",
      GST: "",
      DocType: "",
      StoreId: 0,
      Postatus: 0,
      CreatedAt: "",
      Email: "",
      BranchId: 0,
      HospitalId: 0,
      IsApproved: 0,
      CancelReason: "",
      StoreDeliveryAddress: "",
      EntityId: 0,
    });

    let approvaldetails: any = ref({
      HeaderName: "PO",
      ContentName: "Purchase Order",
      ApprovalCode: 0,
      ApprovalDate: "",
      ApprovalPrice: 0,
      CreatedAt: "",
    });

    let CreatePOAmendment = ref(false);
    let CancelPO = ref(false);
    let CancelPOAmendment = ref(false);
    let VSendMail = ref(false);

    onMounted(async () => {
      await LoadMenus();
      POdetails();
      fetchPOAList();
      fetchGRNList();
      fetchGRNReturnList();
      fetchPaymentList();
    });

    const handleClick = () => {
      showmodalref.value = true;
    };

    function cancelclose() {
      debugger;
      ModelPopupDunction.value.Cancelpop = false;
      //router.back();

      setupHistoryManagement(router, 2);
    }

    const toggle = (event: MouseEvent) => {
      debugger;

      if (
        details.value.Postatus == 0 &&
        details.value.IsApproved == 1 &&
        (details.value.DocType == "4" || details.value.DocType == "5")
      ) {
        CreatePOAmendment.value = true;
      }

      if (
        details.value.Postatus == 0 &&
        details.value.IsApproved == 1 &&
        (details.value.DocType == "4" || details.value.DocType == "5")
      ) {
        CancelPO.value = true;
      }

      if (details.value.Postatus == 0 && details.value.DocType == "6") {
        CancelPOAmendment.value = true;
      }
      if (ApprovalListchange.value[0]?.["IsApproved"] == "1") {
        VSendMail.value = true;
      }
      menu.value.toggle(event);
    };

    const items = ref([
      {
        items: [
          {
            label: "Create an Amendment PO",
            visible: CreatePOAmendment,
            command: async () => {
              CreatePOAmendmentClick();
            },
          },
          {
            label: "Cancel PO",
            icon: "deleteicon pi pi-ban",
            visible: CancelPO,
            command: async () => {
              CancelPOOnClick();
            },
          },
          {
            label: "Cancel PO Amendment",
            icon: "deleteicon pi pi-times",
            visible: CancelPOAmendment,
            command: async () => {
              ModelPopupDunction.value.cancelmodel = true;
            },
          },
          {
            label: "Send E-Mail",
            icon: "editicon pi pi-envelope",
            // visible: VSendMail,
            command: async () => {
              ExportSendMail();
            },
          },
        ],
      },
    ]);

    async function CreatePOAmendmentClick() {
      debugger;
      const response = await MastersService.CheckMenuRights(
        3039, // POAmendment EntityId
        rolesData.RoleId
      );

      let POARights = ref({
        Create: false,
        Update: false,
        Read: false,
        Delete: false,
      });

      let POAObjOperationId = ref({
        CreateId: 0,
        UpdateId: 0,
        ReadId: 0,
        DeleteId: 0,
      });

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          POAObjOperationId.value.CreateId = operation.OperationID;
          POARights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          POAObjOperationId.value.UpdateId = operation.OperationID;
          POARights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          POAObjOperationId.value.ReadId = operation.OperationID;
          POARights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          POAObjOperationId.value.DeleteId = operation.OperationID;
          POARights.value.Delete = operation.IsActive;
        }
      }

      console.log(response);
      let permissionResult: any = checkPermission(POARights, "Add");
      if (permissionResult.hasPermission) {
        router.push({
          name: "POCreation",
          path: "/POCreation",
          query: {
            formId: 1026,
            param: "POAmendment",
            doctype: 6,
            StockTransId: QueryStringValue.value.Id,
            StoreId: details.value.StoreId,
            status: status,
            OperationId: 3039001,
            EntityId: 3039,
            storebranchmapid: route.query.storebranchmapid ?? 0,
            BranchId: route.query.BranchId ?? 0,
            IsFlag: 1,
            IsDraft: 0,
          },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    async function ExportSendMail() {
      try {
        debugger;
        let obj = {
          FormId:
            details.value.DocType == 4 || details.value.DocType == 5 ? 14 : 56,
          ModuleId: 3,
          OrganizationId: HospitalId,
          BranchId: QueryStringValue.value.BranchId,
          JsonValue:
            "{ Id:" +
            QueryStringValue.value.Id +
            ",hospitalid:'" +
            HospitalId +
            "',branchid:'" +
            QueryStringValue.value.BranchId +
            "'}",
          // FileName: "PO" + QueryStringValue.value.Id,
          FileName: details.value.Po,
          PathView:
            details.value.DocType == 4 || details.value.DocType == 5
              ? "PO"
              : "POA",
          DeptRoleId: DeptRoleMapId,
          EntityTransactionId: QueryStringValue.value.Id,
          EntityOperationId:
            details.value.DocType == 4 || details.value.DocType == 5
              ? 599
              : 464,
          Email: details.value.Email,
          SupplierName: details.value.SupplierName,
          PONumber: details.value.Po,
          PODate: moment(details.value.Podate).format("dd MMM yyyy | h:mma"),
          TotalAmount: details.value.Price,
          DeliveryAddress: details.value.Address,
          ItemList: itemslist.value,
          UserId: usersData.UserId,
          UserName: usersData.UserName,
          ContactAddress: usersData.AddressVar,
          PhoneNumber: usersData.phoneNumber,
          Position: rolesData.RoleName,
          StoreDeliveryAddress: details.value.StoreDeliveryAddress,
        };

        const result = await commonService.ExportSendMail(obj);
        if (result["result"] == "Success") {
          toast.add({
            severity: "success",
            summary: "Mail Sent Successfully",
            detail: "",
            life: 3000,
          });
        }
        console.log(result);
      } catch (error) {
        console.log(error);
      }
    }

    const next = () => {
      if (activeIndex.value === 3) activeIndex.value = 0;
      else activeIndex.value++;
      isActive.value = true;
    };

    const prev = () => {
      if (activeIndex.value === 0) activeIndex.value = 3;
      else activeIndex.value--;
    };

    const item = ref([
      {
        label: "Personal",
        to: "/",
      },
      {
        label: "Seat",
        to: "/Masters",
      },
      {
        label: "Payment",
        to: "/SupplierMasterCreation",
      },
      {
        label: "Confirmation",
        to: "/GenericMasterTableview",
      },
    ]);
    let headers: any = [];
    const POheaders = [
      {
        header: t("storetabdetails.poammendment.Code"),
        field: "DocNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.poammendment.PODate"),
        field: "DocDateHR",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.poammendment.RefNo"),
        field: "RefNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.poammendment.FromStore"),
        field: "FromStoreName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow1",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.poammendment.ToStore"),
        field: "ToStoreName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow1",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.poammendment.Supplier"),
        field: "SupplierName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      // {
      //   header: t("storetabdetails.poammendment.ItemCount"),
      //   field: "ItemCount",
      //   bodyclass: "bluecolor right_td",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   class: "smallwidth",
      // },
      {
        header: t("storetabdetails.poammendment.Value"),
        field: "Amount",
        bodyclass: "boldclass right_td",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      // {
      //   field: "",
      //   fieldDisplay: "false",
      //   header: t("storetabdetails.po.PendingSince"),
      //   slot: "waitingsince",
      //   sortable: false,
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   class: "mediumwidth",
      // },
      // {
      //   header: t("storetabdetails.poammendment.ApprovalStatus"),
      //   field: "",
      //   fieldDisplay: "false",
      //   slot: "ApprovalStatus",
      //   sortable: false,
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   class: "",
      // },
    ];
    const grnheaders = [
      // {
      //   header: t("storetabdetails.grn.sno"),
      //   field: "RowNumber",
      //   class: "filterdisplaynone",
      // },
      {
        header: t("storetabdetails.grn.Code"),
        field: "DocNo",
        // fieldDisplay: "false",
        // slot: "DocNo",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "",
        class: "smallwidth",
      },
      // {
      //   header: t("storetabdetails.grn.BranchName"),
      //   field: "BranchName",
      //   class: "filterdisplaynone",
      // },

      {
        header: t("storetabdetails.grn.Date"),
        field: "DocDateHR",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grn.SupplierName"),
        field: "SupplierName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      // {
      //   header: t("storetabdetails.grn.Address"),
      //   field: "Address",
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   bodyclass: "text_overflow2",
      //   class: "mediumwidth",
      // },
      {
        header: t("storetabdetails.grn.GSTNO"),
        field: "GSTNO",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.grn.PaymentTermsDesc"),
        field: "PaymentTermsDesc",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.grn.DeliTermsDesc"),
        field: "DeliTermsDesc",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.grn.GrnPo"),
        field: "RefNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grn.InvoiceNo"),
        field: "InvoiceNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grn.InvoiceDate"),
        field: "InvoiceDateHR",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },

      // {
      //   header: t("storetabdetails.grn.ItemCount"),
      //   field: "ItemCount",
      //   bodyclass: "right_td",
      //   class: "smallwidth",
      // },
      {
        header: t("storetabdetails.grn.ItemQty"),
        field: "ItemQty",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grn.Value"),
        field: "NetAmount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grn.ApprovalStatus"),
        field: "",
        fieldDisplay: "false",
        slot: "IsApproved",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grn.PaymentStatus"),
        field: "",
        fieldDisplay: "false",
        slot: "PaymentStatus",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      // {
      //   field: "action",
      //   header: "",
      //   slot: "action",
      //   frozencolumn: true,
      //   sortable: false,
      //   // hide: ColumnVisible.value,
      //   class: "filterdisplaynone last-column-position",
      //   fieldDisplay: "false",
      // },
    ];

    const grnreturnheaders = [
      {
        header: t("storetabdetails.grnreturn.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("storetabdetails.po.Status"),
        field: "POStatusName",
        fieldDisplay: "false",
        slot: "Status",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        // bodyclass: "text_overflow2",
      },
      // {
      //   header: t("storetabdetails.grnreturn.BranchName"),
      //   field: "BranchName",
      //   class: "filterdisplaynone",
      // },
      {
        header: t("storetabdetails.grnreturn.Code"),
        field: "DocNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.Date"),
        field: "DocDateHR",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.InvoiceNo"),
        field: "InvoiceNo",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.SupplierName"),
        field: "SupplierName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },

      // {
      //   header: t("storetabdetails.grnreturn.ItemCount"),
      //   field: "ItemCount",
      //   bodyclass: "right_td",
      //   class: "smallwidth",
      // },
      {
        header: t("storetabdetails.grnreturn.Value"),
        field: "Amount",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.ReturnType"),
        field: "ReturnTypeName",
        // bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.CreatedBy"),
        field: "CreatedByName",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.CreatedAt"),
        field: "CreatedAtHR",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.ModifiedBy"),
        field: "ModifiedByName",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.grnreturn.ModifiedAt"),
        field: "ModifiedAtHR",
        class: "smallwidth",
      },
      // {
      //   field: "action",
      //   header: "",
      //   slot: "action",
      //   frozencolumn: true,
      //   sortable: false,
      //   // hide: ColumnVisible.value,
      //   class: "filterdisplaynone last-column-position",
      //   fieldDisplay: "false",
      // },
    ];

    const paymentheaders = [
      {
        header: t("5005.paymentterms.terms"),
        field: "PaymentTermsDesc",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("5005.description"),
        field: "Description",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        bodyclass: "text_overflow1",
      },
      {
        header: t("5005.percentage"),
        field: "",
        fieldDisplay: "false",
        slot: "Percentage",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "",
      },
      {
        header: t("5005.amount"),
        field: "",
        fieldDisplay: "false",
        slot: "Amount",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "",
      },
      {
        header: t("5005.noOfDays"),
        field: "Days",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("5005.isapproved"),
        field: "",
        fieldDisplay: "false",
        slot: "ApprovalStatus",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "",
      },
      {
        header: t("5005.Paymentstatus"),
        field: "Status",
        fieldDisplay: "false",
        slot: "StatusSlot",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },

      {
        header: t("5005.upload"),
        field: "",
        fieldDisplay: "false",
        slot: "Upload",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "",
      },
      {
        header: t("5005.File"),
        field: "",
        fieldDisplay: "false",
        slot: "View",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "",
      },
      {
        header: t("5005.Initiate"),
        field: "",
        fieldDisplay: "false",
        slot: "Initiate",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "",
      },
      {
        header: t("5005.Reason"),
        field: "Reason",
        fieldDisplay: "false",
        slot: "ReasonSlot",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
        bodyclass: "text_overflow2",
      },
      {
        header: t("5005.Action"),
        field: "",
        fieldDisplay: "false",
        slot: "Action",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "mediumwidth",
      },
    ];

    const Approvalheaders = [
      {
        header: "RoleName",
        field: "RoleName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: "ApprovalStatus",
        field: "IsApproved",
        fieldDisplay: "false",
        slot: "ApprovalStatus",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "",
      },
      {
        header: "Approved By",
        field: "",
        fieldDisplay: "false",
        slot: "ApprovedBySlot",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "",
      },
      {
        header: "InitiatedAt",
        field: "InitiatedAt",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: "ApprovedAt",
        field: "ApprovedAt",
        fieldDisplay: "false",
        slot: "ApprovedAtSlot",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "",
      },
      {
        header: "Remarks",
        field: "Remarks",
        fieldDisplay: "false",
        slot: "RemarksSlot",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
    ];
    const POdetails = async () => {
      debugger;
      try {
        loading.value = true;
        debugger;
        const response = await commonService.GetByStockWOTransId(
          QueryStringValue.value.Id
        );
        debugger;
        if (response["result"][0]) {
          let data = response["result"][0];
          console.log("sdjhsdhjdsjhsdjh", response["result"][0]);
          console.log(data);
          details.value.Price = Number(data.grossamount || 0)
            .toFixed(2)
            .replace(/\.00$/, "");
          details.value.SupplierId = data.SupplierId;
          details.value.Podate = data.DocDateHR;
          details.value.Po = data.DocNo;
          details.value.RefNo = data.RefNo;
          details.value.CreatedAt = data.CreatedAt;

          details.value.DocType = data.DocType;
          details.value.StoreId = data.StoreId;
          details.value.Postatus = data.Status;

          details.value.BranchId = data.BranchId;
          details.value.HospitalId = data.HospitalId;
          details.value.IsApproved = data.IsApproved;
          details.value.CancelReason = data.CancelReason;

          details.value.EntityId = data.EntityId;
          details.value.IsDraft = data.IsDraft;

          approvaldetails.value.ApprovalCode = data.DocNo;
          approvaldetails.value.ApprovalDate = data.DocDateHR;
          approvaldetails.value.CreatedAt = data.CreatedAt;
          approvaldetails.value.ApprovalPrice = data.grossamount || 0;
          if (details.value.DocType == "4" || details.value.DocType == "5") {
            SummaryName.value = "PO";
          } else if (details.value.DocType == "6") {
            SummaryName.value = "PO Amendment";
          } else {
            console.log(details.value.DocType);
          }

          if (details.value.DocType == "6") {
            buttonValue.value = false;
            POAmendmentshow.value = true;
          }

          details.value.Paymentterms = data.PaymentTermsName;
          details.value.deliveryterms = data.DeliveryTermsName;
          details.value.StoreDeliveryAddress = data.DeliveryAddress;
          details.value.SupplierAddress = data.SupplierAddress;

          getfindonedata();
        }

        loading.value = false;
      } catch (error) {
        alert(error);
      }
    };

    async function getfindonedata() {
      debugger;
      try {
        let response = await service.EditData(details.value.SupplierId);
        debugger;
        const data1 = response["result"][0];
        console.log(data1);

        details.value.SupplierName = data1.Name;
        details.value.Address = data1.Address;
        details.value.GST = data1.GSTNO;
        details.value.Email = data1.Email;
      } catch (error) {
        console.log(error);
      }
    }

    function datapass() {
      debugger;

      router.push({
        name: "POCreation",
        path: "/POCreation",
      });
    }

    function CancelPOOnClick() {
      debugger;

      ObjCancelPopUp.value.PopUpHeaderName = t("confirmation.cancelpo");
      ObjCancelPopUp.value.TextAareaName = t("confirmation.cancelreason");
      ObjCancelPopUp.value.CancelReason = "";

      ObjCancelPopUp.value.CancelReasonPopup = true;

      ObjCancelPO.value.EntityId = details.value.EntityId;
      ObjCancelPO.value.EntityOperationId = 3044005;
      ObjCancelPO.value.Status = "4";
      ObjCancelPO.value.IsApproved = 0;
      ObjCancelPO.value.Type = 1;
      ObjCancelPO.value.DocNo = details.value.Po;

      ObjCancelPopUp.value.ConfirmPopupHeader = t("confirmation.confirmcancel");
      ObjCancelPopUp.value.ConfirmPopupContent = t(
        "confirmation.doyouwanttocancel"
      );
    }

    function RevertPO() {
      debugger;

      ObjCancelPopUp.value.PopUpHeaderName = t("confirmation.revertpo");
      ObjCancelPopUp.value.TextAareaName = t("confirmation.revertreason");
      ObjCancelPopUp.value.CancelReason = "";

      ObjCancelPopUp.value.CancelReasonPopup = true;

      ObjCancelPO.value.EntityId = details.value.EntityId;
      ObjCancelPO.value.EntityOperationId = 3044006;
      ObjCancelPO.value.Status = "0";
      ObjCancelPO.value.IsApproved = 0;
      ObjCancelPO.value.Type = 2;
      ObjCancelPO.value.DocNo = details.value.Po;

      ObjCancelPopUp.value.ConfirmPopupHeader = t("confirmation.conformrevert");
      ObjCancelPopUp.value.ConfirmPopupContent = t(
        "confirmation.doyouwanttorevert"
      );
    }

    function SaveCancelPO() {
      debugger;
      if (ObjCancelPopUp.value.CancelReason == "") {
        toast.add({
          severity: "info",
          summary: "Enter Reason",
          detail: "",
          life: 3000,
        });
      } else {
        ModelPopupDunction.value.cancelmodel = true;
      }
    }

    const Statuschange = async () => {
      debugger;
      try {
        ObjCancelPO.value.Id = Number(QueryStringValue.value.Id);
        ObjCancelPO.value.CancelReason = ObjCancelPopUp.value.CancelReason;
        ObjCancelPO.value.BranchId = details.value.BranchId;
        ObjCancelPO.value.HospitalId = details.value.HospitalId;
        ObjCancelPO.value.DeptRoleId = rolesData.DeptRoleMapId;
        ObjCancelPO.value.StoreId = rolesData.StoreId;

        if (details.value.DocType == "4" || details.value.DocType == "5") {
          ModelPopupDunction.value.CancelModelTxt = t(
            "confirmation.pocancelsuccess"
          );
        } else {
          ObjCancelPO.value.Status = "5";
          ModelPopupDunction.value.CancelModelTxt = t(
            "confirmation.poammendcancelsuccess"
          );
        }
        const response = await commonService.StockWOOutStatusChanged(
          ObjCancelPO.value
        );

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
          ModelPopupDunction.value.cancelmodel = false;
          if (ObjCancelPO.value.EntityOperationId == 3044005) {
            ModelPopupDunction.value.Cancelpop = true;
          } else if (ObjCancelPO.value.EntityOperationId == 3044006) {
            ModelPopupDunction.value.RevertModelTxt = t(
              "confirmation.porevertsuccess"
            );
            ModelPopupDunction.value.Revertpop = true;
          }
        } else {
          alert("Somthing went wrong");
        }
      } catch (error) {
        console.log(error);
      }
    };

    const convertedDate = ref("");
    const getConvertedDate = (dateString, format) => {
      convertedDate.value = moment(dateString).format(format);
      return convertedDate.value;
    };

    async function getApprovaldata(Id) {
      debugger;
      try {
        let response = await PoApprovalService.GetPOApprovalList(
          Id,
          usersData.OrganizationId,
          usersData.BranchId,
          Entitydata.value.EntityId
        );

        ApprovalList.value = response["result"];
        ApprovalListchange.value = response["result"].filter(
          (item) => item.DepRoleID == DeptRoleMapId
        );
        console.log("approval data", ApprovalList.value);
      } catch (error) {
        console.log(error);
      }
    }

    let SuccessfullPopUp = ref({
      accept: ref(false),
      decline: ref(false),
    });

    let isForm = ref({
      EntityOperationId: 0,
      Id: 0,
      EntityApprovalMapID: 0,
      EntityTransactionId: 0,
      ApproverID: usersData.UserId,
      DepRoleID: rolesData.DeptRoleMapId,
      IsApproved: 0,
      ApprovedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      Remarks: "",
      EntityId: 0,
      ApprovalURL: "",
    });

    async function Approve(Values) {
      debugger;
      try {
        let rowToAssign = null;
        for (let i = 0; i < ApprovalListchange.value.length; i++) {
          if (ApprovalListchange.value[i]["IsApproved"] === 0) {
            rowToAssign = ApprovalListchange.value[i];
            break;
          }
        }
        if (rowToAssign) {
          isForm.value.EntityOperationId = rowToAssign["EntityOperationId"];
          isForm.value.Id = rowToAssign["ID"];
          isForm.value.EntityTransactionId = rowToAssign["EntityTransactionId"];
          isForm.value.IsApproved = Values.Approvalstatus;
          isForm.value.Remarks = Values.Remarks;
          isForm.value.EntityId = details.value.EntityId;
          isForm.value.ApprovalURL = rowToAssign["ApprovalURL"];
        }
        let response;
        if (isForm.value.IsApproved == 1) {
          response = await PoApprovalService.POApproval(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            if (response["result"] == 1) {
              // UpdateApprovalStatus();
            }
            SuccessfullPopUp.value.accept = true;
          } else {
            alert("Somthing went wrong");
          }
        } else if (isForm.value.IsApproved == 3) {
          response = await PoApprovalService.POReject(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            // UpdateApprovalStatus();
            SuccessfullPopUp.value.decline = true;
          } else {
            alert("Somthing went wrong");
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    async function UpdateApprovalStatus(Id, Status, ApprovalURL) {
      debugger;
      let message = "";
      try {
        if (ApprovalURL == "POPayment") {
          const response =
            await POPaymentTermsService.UpdatePaymentApprovalStatus(Id, Status);
          message = response["ErrorInfo"].ErrorCode;
        } else if (ApprovalURL == "PO") {
          const response = await commonService.UpdateApprovalStatus(
            QueryStringValue.value.Id,
            isForm.value.IsApproved
          );

          message = response["ErrorInfo"].ErrorCode;
        }

        if (message == null) {
          fetchPaymentList();
        }
      } catch (error) {
        console.log(error);
      }
    }
    const AddItems = (value) => {
      debugger;
      console.log(value);
      itemslist.value = value;
    };
    function removeHtmlTags(input: string): string {
      return input?.replace(/<\/?[^>]+>/gi, ""); // Regular expression to match HTML tags
    }

    const fetchPOAList = async () => {
      try {
        loading1.value = true;
        const response = await commonService.GetPOAListByPoId(
          QueryStringValue.value.Id
        );
        POList.value = response["result"] || [];
        let index = TabArray.value.findIndex(
          (item: any) => item.EntityId === 3138
        );
        TabArray.value[index].List = POList.value;
        TabArray.value[index].headers = POheaders;
        TabArray.value[index].globalFilterFields = ref(
          POheaders.map((col) => col.field)
        );
        TabArray.value[index].filters = POfilters;
        TabArray.value[index].ListLength = TabArray.value[index].List.length;
        loading1.value = false;
      } catch (error) {
        console.error("Error fetching POA list:", error);
        loading1.value = false;
      }
    };
    const fetchGRNList = async () => {
      try {
        loading1.value = true;
        const response = await StockInService.GetGRNListByPoId(
          QueryStringValue.value.Id
        );
        GRNList.value = response["result"] || [];
        let index = TabArray.value.findIndex(
          (item: any) => item.EntityId === 3135
        );
        TabArray.value[index].List = GRNList.value;
        TabArray.value[index].headers = grnheaders;
        TabArray.value[index].globalFilterFields = ref(
          grnheaders.map((col) => col.field)
        );
        TabArray.value[index].filters = grnfilters;
        TabArray.value[index].ListLength = TabArray.value[index].List.length;
        loading1.value = false;
      } catch (error) {
        console.error("Error fetching POA list:", error);
        loading1.value = false;
      }
    };
    const fetchGRNReturnList = async () => {
      try {
        loading1.value = true;
        const response = await StockOutService.GetGRNReturnListByPoId(
          QueryStringValue.value.Id
        );
        GRNReturnList.value = response["result"] || [];
        let index = TabArray.value.findIndex(
          (item: any) => item.EntityId === 3136
        );
        TabArray.value[index].List = GRNReturnList.value;
        TabArray.value[index].headers = grnreturnheaders;
        TabArray.value[index].globalFilterFields = ref(
          grnreturnheaders.map((col) => col.field)
        );
        TabArray.value[index].filters = grnfilters;
        TabArray.value[index].ListLength = TabArray.value[index].List.length;
        loading1.value = false;
      } catch (error) {
        console.error("Error fetching POA list:", error);
        loading1.value = false;
      }
    };

    const fetchPaymentList = async () => {
      try {
        loading1.value = true;
        const response = await POPaymentTermsService.GetPaymentListByPoId(
          QueryStringValue.value.Id
        );
        PaymentList.value = response["result"] || [];
        debugger;
        uploadedTableList.value = [];
        for (let i = 0; i < PaymentList.value.length; i++) {
          PaymentList.value[i].CreatedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          PaymentList.value[i].ModifiedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          PaymentList.value[i].Amount = PaymentList.value[i].Amount.toFixed(
            2
          ).replace(/\.00$/, "");
          if (PaymentList.value[i]["FileUpload"]) {
            const fileUploads = PaymentList.value[i]["FileUpload"].split(",");

            fileUploads.forEach((FileUpload) => {
              const fileName = FileUpload.split("/").pop();
              if (fileName) {
                const fileEntry = {
                  uploadId: PaymentList.value[i]["Id"],
                  fileName: fileName.trim(),
                  fullPath: FileUpload.trim(),
                };
                uploadedTableList.value.push(fileEntry);
              }
            });
          }
        }

        let index = TabArray.value.findIndex(
          (item: any) => item.EntityId === 3137
        );
        TabArray.value[index].headers = paymentheaders;
        TabArray.value[index].List = PaymentList.value;
        TabArray.value[index].globalFilterFields = ref(
          paymentheaders.map((col) => col.field)
        );
        TabArray.value[index].List.forEach((item) => {
          item.LastValidAmount = item.Amount || 0;
          item.LastValidPercentage = Number(item.Percentage) || 0;
        });
        TabArray.value[index].filters = paymentfilters;
        TabArray.value[index].ListLength = TabArray.value[index].List.length;
        loading1.value = false;
      } catch (error) {
        console.error("Error fetching POA list:", error);
        loading1.value = false;
      }
    };
    let menuarray: any = ref([]);
    let TabArray: any = ref([]);

    async function LoadMenus() {
      debugger;
      debugger;
      let response = await MastersService.GetMenus(
        11,
        rolesData.RoleId,
        usersData.OrganizationId
      );

      console.log("MenuListStoreTabDetails", response["result"]);
      menuarray.value = response["result"];
      TabArray.value = menuarray.value.map((items) => {
        (items.ListLength = 0),
          (items.headers = []),
          (items.List = []),
          (items.globalFilterFields = []),
          (items.filters = []);
        return items;
      });
    }
    let Entitydata = ref();
    function TabClick(SubMenuDetails, index) {
      debugger;
      let InstantEntityId = {
        EntityId: SubMenuDetails.EntityId,
      };
      localStorage.removeItem("EntityData");
      localStorage.setItem("EntityData", JSON.stringify(InstantEntityId));
      Entitydata.value = localStorage.getItem("EntityData");
      Entitydata.value = JSON.parse(Entitydata.value);
      fetchPaymentList();
    }

    async function InitiateOnClick(data, Reason) {
      debugger;

      const response = await POPaymentTermsService.UpdatePaymentInitiate(
        data,
        true,
        3137001,
        DeptRoleMapId,
        Entitydata.value.EntityId,
        Reason
      );
      fetchPaymentList();
    }

    const handleChangedocument = async (event: Event, data) => {
      debugger;
      debugger;
      let result;
      let files: any = "";
      const input = event.target as HTMLInputElement;
      files = input["files"];
      console.log(files);
      if (files && files.length > 0) {
        debugger;
        for (let i = 0; i < files.length; i++) {
          let form = new FormData();
          console.log(files[i]);
          form.append("file", files[i]);
          console.log(form);
          result = await common.uploadquotation(form, "TransactionFiles");
          console.log("Uploaded :", result);
          let ResponseValue = result;
          ResponseValue["Id"] = files[i];
          fullPath.value = result.uploadPath;
          console.log("Uploaded :", data.Id);
          ResponseValue["uploadId"] = JSON.stringify(data.Id);
          uploadedTableList.value.push(ResponseValue);
        }
        debugger;
        const filenames = uploadedTableList.value
          .filter((item) => item.uploadId == JSON.stringify(data.Id))
          .map((item) => item.fileName)
          .join(", ");
        console.log("Filenames to update for current Id:", filenames);
        const FileUploadresult =
          await POPaymentTermsService.UpdatePaymentFileUplaod(
            data.Id,
            filenames
          );
      }
      debugger;
      console.log(uploadedTableList.value);
    };
    function fileviewer(data) {
      debugger;
      const newTabUrl = data;
      window.open(newTabUrl, "_blank");
    }
    const fileuploadDelete = async (data) => {
      debugger;
      DeletedFileUpload.push(data.Id);
      uploadedTableList.value = uploadedTableList.value.filter(
        (item) => item.fileName != data.fileName
      );

      const remainingFileNames = uploadedTableList.value
        .filter((item) => item.uploadId == data.uploadId)
        .map((item) => item.fileName)
        .join(", ");

      if (DeletedFileUpload.length > 0) {
        debugger;
        const result = await POPaymentTermsService.UpdatePaymentFileUplaod(
          data.uploadId,
          remainingFileNames
        );
      }
    };
    const grndata = ref({
      Id: "",
      BranchId: "",
      EntityId: "",
      DocType: "",
    });
    const grnreturndata = ref({
      param: "",
      StoreId: "",
      status: "",
      Type: "",
      refNo: "",
      RefId: "",
      SupplierId: "",
      OperationId: "",
      EntityId: "",
      Id: "",
      storebranchmapid: "",
      BranchId: "",
      IsGRNDetails: "",
    });
    const POdata = ref({
      Id: "",
    });
    async function RowClick(event, EntityId) {
      debugger;
      if (event.data.Initiate) {
        let index = TabArray.value.findIndex(
          (item: any) => item.EntityId === EntityId
        );
        if (index == 2) {
          grndata.value.Id = event.data.Id;
          grndata.value.BranchId = event.data.BranchId;
          grndata.value.EntityId = event.data.EntityId;
          grndata.value.DocType = event.data.DocType;
          grnvisible.value = true;
        } else if (index == 3) {
          grnreturndata.value.param = "GRNReturn";
          grnreturndata.value.StoreId = event.data.StoreId;
          grnreturndata.value.status = event.data.Status;
          grnreturndata.value.Type = event.data.Type;
          grnreturndata.value.refNo = event.data.refno;
          grnreturndata.value.RefId = event.data.RefId;
          grnreturndata.value.SupplierId = event.data.SupplierId;
          grnreturndata.value.OperationId = event.data.OperationId;
          grnreturndata.value.EntityId = event.data.EntityId;
          grnreturndata.value.Id = event.data.Id;
          grnreturndata.value.storebranchmapid = event.data.storebranchmapid;
          grnreturndata.value.BranchId = event.data.storebranchmapid;
          grnreturndata.value.IsGRNDetails = event.data.IsGRNDetails;

          grnreturnvisible.value = true;
        } else if (index == 1) {
          POdata.value.Id = event.data.Id;
          POAvisible.value = true;
        } else if (index == 4 && !buttondisable.value) {
          await getApprovaldata(event.data.Id);
          ApprovalList.value = ApprovalList.value.map((item: any) => {
            item.InitiatedAt =
              event.data.InitiatedAt != null ? event.data.InitiatedAt : "-";
            return item;
          });
          POPaymentsvisible.value = true;
        }
      }
    }

    async function ViewDetails(data, EntityId) {
      debugger;
      if (data.Initiate) {
        let index = TabArray.value.findIndex(
          (item: any) => item.EntityId === EntityId
        );
        if (index == 2) {
          grndata.value.Id = data.Id;
          grndata.value.BranchId = data.BranchId;
          grndata.value.EntityId = data.EntityId;
          grndata.value.DocType = data.DocType;
          grnvisible.value = true;
        } else if (index == 3) {
          grnreturndata.value.param = "GRNReturn";
          grnreturndata.value.StoreId = data.StoreId;
          grnreturndata.value.status = data.Status;
          grnreturndata.value.Type = data.Type;
          grnreturndata.value.refNo = data.refno;
          grnreturndata.value.RefId = data.RefId;
          grnreturndata.value.SupplierId = data.SupplierId;
          grnreturndata.value.OperationId = data.OperationId;
          grnreturndata.value.EntityId = data.EntityId;
          grnreturndata.value.Id = data.Id;
          grnreturndata.value.storebranchmapid = data.storebranchmapid;
          grnreturndata.value.BranchId = data.storebranchmapid;
          grnreturndata.value.IsGRNDetails = data.IsGRNDetails;

          grnreturnvisible.value = true;
        } else if (index == 1) {
          POdata.value.Id = data.Id;
          POAvisible.value = true;
        } else if (index == 4 && !buttondisable.value) {
          await getApprovaldata(data.Id);
          ApprovalList.value = ApprovalList.value.map((item: any) => {
            item.InitiatedAt =
              data.InitiatedAt != null ? data.InitiatedAt : "-";
            return item;
          });
          POPaymentsvisible.value = true;
        }
      }
    }

    const CopyTableindex = ref();
    const EditPayment = (data, TableIndex) => {
      debugger;
      CopyPaymentList.value = JSON.parse(
        JSON.stringify(TabArray.value[TableIndex].List)
      );
      data.EditFlag = true;
      CopyTableindex.value = TableIndex;
      emit("CopyPaymentListObj", CopyPaymentList.value);
    };

    let CopyPaymentList = ref();

    const validatePaymentTermsPercentages = (paymentList) => {
      debugger;
      if (!paymentList || paymentList.length === 0) {
        return { isValid: false, message: "No payment terms data found" };
      }
      const percentages = paymentList.map(
        (item) => parseFloat(item.Percentage) || 0
      );

      const zeroPercentLines = percentages.filter((p) => p === 0);

      if (zeroPercentLines.length > 0) {
        return {
          isValid: false,
          message:
            "Cannot update, All line item should have some percentage value. please adjust the percentage",
        };
      }

      return { isValid: true, message: "" };
    };

    const UpdatePayment = async (data, TableIndex) => {
      debugger;
      const isValidAmount = !isNaN(data.Amount) && Number(data.Amount) >= 0;
      if (!isValidAmount) {
        toast.add({
          severity: "error",
          summary: "Invalid Amount",
          detail: "Please enter a valid non-negative amount.",
          life: 3000,
        });
        return;
      }
      const isValidPercentage =
        !isNaN(data.Percentage) && Number(data.Percentage) >= 0;
      if (!isValidPercentage) {
        toast.add({
          severity: "error",
          summary: "Invalid Amount",
          detail: "Please enter a valid non-negative Percentage.",
          life: 3000,
        });
        return;
      }
      const validationResult = validatePaymentTermsPercentages(
        TabArray.value[TableIndex].List
      );
      if (!validationResult.isValid) {
        toast.add({
          severity: "error",
          summary: "Invalid Percentage Distribution",
          detail: validationResult.message,
          life: 5000,
        });
        return;
      }

      const result = await POPaymentTermsService.insert(
        TabArray.value[TableIndex].List
      );
      if (result["result"].length > 0) {
        emit("updatePayment", Number(data.Amount));
        toast.add({
          severity: "success",
          summary: "Updated Successfully",
          detail: "",
          life: 3000,
        });
      }
      data.EditFlag = false;
    };
    const UndoPayment = async (data, TableIndex) => {
      debugger;
      TabArray.value[TableIndex].List = CopyPaymentList.value;
      data.EditFlag = false;
    };

    // const validateAmount = (Amount, Id, TableIndex) => {
    //   debugger;
    //   // Calculate the total amount
    //   const currentIndex = TabArray.value[TableIndex].List.findIndex(
    //     (row) => row.Id === Id
    //   );
    //   const totalAmount = Number(details.value.Price);
    //   // Update the percentage for the current item and round it to 2 decimal places
    //   TabArray.value[TableIndex].List[currentIndex].Percentage = (
    //     (Number(Amount) / totalAmount) *
    //     100
    //   )
    //     .toFixed(2)
    //     .replace(/\.00$/, "");
    //   // Recalculate the total percentage
    //   const totalPercentage = TabArray.value[TableIndex].List.reduce(
    //     (total, item) => total + Number(item.Percentage),
    //     0
    //   );
    //   // Update the current item’s Amount
    //   let remainingPercentage = 100 - totalPercentage;
    //   const otherItemsCount = TabArray.value[TableIndex].List.length - 1;
    //   const adjustPercentageForItem = (index, percentageToAdd) => {
    //     if (index < TabArray.value[TableIndex].List.length) {
    //       const item = TabArray.value[TableIndex].List[index];
    //       item.Percentage = Number(item.Percentage) + percentageToAdd;
    //       item.Amount = ((Number(item.Percentage) / 100) * totalAmount)
    //         .toFixed(2)
    //         .replace(/\.00$/, "");
    //       item.Percentage = item.Percentage.toFixed(2).replace(/\.00$/, "");
    //     }
    //   };

    //   // Adjust percentage when remainingPercentage is positive
    //   if (remainingPercentage > 0) {
    //     if (otherItemsCount > 0) {
    //       if (currentIndex === otherItemsCount) {
    //         let nextIndex = TabArray.value[TableIndex].List.findIndex(
    //           (item) => item.Status === 0
    //         );
    //         if (nextIndex !== -1) {
    //           adjustPercentageForItem(nextIndex, remainingPercentage);
    //         }
    //       } else {
    //         let nextIndex = currentIndex + 1;
    //         nextIndex = TabArray.value[TableIndex].List.findIndex(
    //           (item, idx) => idx > currentIndex && item.Status === 0
    //         );
    //         if (nextIndex !== -1) {
    //           adjustPercentageForItem(nextIndex, remainingPercentage);
    //         }
    //       }
    //     }
    //   }
    //   // Adjust percentage when remainingPercentage is negative
    //   else if (remainingPercentage < 0) {
    //     let nextIndex = currentIndex + 1;
    //     if (nextIndex >= TabArray.value[TableIndex].List.length) nextIndex = 0;

    //     while (remainingPercentage < 0) {
    //       const item = TabArray.value[TableIndex].List[nextIndex];
    //       if (item.Status === 0 && Number(item.Percentage) > 0) {
    //         if (Number(item.Percentage) >= Math.abs(remainingPercentage)) {
    //           adjustPercentageForItem(nextIndex, remainingPercentage);
    //           remainingPercentage = 0;
    //         } else {
    //           remainingPercentage += Number(item.Percentage);
    //           item.Percentage = 0;
    //           item.Amount = 0;
    //         }
    //       }
    //       nextIndex = (nextIndex + 1) % TabArray.value[TableIndex].List.length; // Cycle through the list
    //     }
    //   }
    // };
    // const validatePercentage = (Percentage, Id, TableIndex) => {
    //   debugger;
    //   const currentIndex = TabArray.value[TableIndex].List.findIndex(
    //     (row) => row.Id === Id
    //   );
    //   const totalAmount = Number(details.value.Price);
    //   const totalPercentage = TabArray.value[TableIndex].List.reduce(
    //     (total, item) => total + Number(item.Percentage),
    //     0
    //   );

    //   // Update the current item’s Amount
    //   TabArray.value[TableIndex].List[currentIndex].Amount = (
    //     (TabArray.value[TableIndex].List[currentIndex].Percentage / 100) *
    //     totalAmount
    //   )
    //     .toFixed(2)
    //     .replace(/\.00$/, "");

    //   let remainingPercentage = 100 - totalPercentage;
    //   const otherItemsCount = TabArray.value[TableIndex].List.length - 1;

    //   const adjustPercentageForItem = (index, percentageToAdd) => {
    //     if (index < TabArray.value[TableIndex].List.length) {
    //       const item = TabArray.value[TableIndex].List[index];
    //       item.Percentage = Number(item.Percentage) + percentageToAdd;
    //       item.Amount = ((Number(item.Percentage) / 100) * totalAmount)
    //         .toFixed(2)
    //         .replace(/\.00$/, "");
    //     }
    //   };

    //   // Adjust percentage when remainingPercentage is positive
    //   if (remainingPercentage > 0) {
    //     if (otherItemsCount > 0) {
    //       if (currentIndex === otherItemsCount) {
    //         let nextIndex = TabArray.value[TableIndex].List.findIndex(
    //           (item) => item.Status === 0
    //         );
    //         if (nextIndex !== -1) {
    //           adjustPercentageForItem(nextIndex, remainingPercentage);
    //         }
    //       } else {
    //         let nextIndex = currentIndex + 1;
    //         nextIndex = TabArray.value[TableIndex].List.findIndex(
    //           (item, idx) => idx > currentIndex && item.Status === 0
    //         );
    //         if (nextIndex !== -1) {
    //           adjustPercentageForItem(nextIndex, remainingPercentage);
    //         }
    //       }
    //     }
    //   }
    //   // Adjust percentage when remainingPercentage is negative
    //   else if (remainingPercentage < 0) {
    //     let nextIndex = currentIndex + 1;
    //     if (nextIndex >= TabArray.value[TableIndex].List.length) nextIndex = 0;

    //     while (remainingPercentage < 0) {
    //       const item = TabArray.value[TableIndex].List[nextIndex];
    //       if (item.Status === 0 && Number(item.Percentage) > 0) {
    //         if (Number(item.Percentage) >= Math.abs(remainingPercentage)) {
    //           adjustPercentageForItem(nextIndex, remainingPercentage);
    //           remainingPercentage = 0;
    //         } else {
    //           remainingPercentage += Number(item.Percentage);
    //           item.Percentage = 0;
    //           item.Amount = 0;
    //         }
    //       }
    //       nextIndex = (nextIndex + 1) % TabArray.value[TableIndex].List.length; // Cycle through the list
    //     }
    //   }
    // };
    const validateAmount = (Amount, Id, TableIndex) => {
      debugger;
      const currentList = TabArray.value[TableIndex].List;
      const currentIndex = currentList.findIndex((row) => row.Id === Id);
      const totalAmount = Number(details.value.Price);
      const inputAmount = Number(Amount);

      let approvedSum = 0;
      for (let i = 0; i < currentIndex; i++) {
        if (currentList[i].IsApproved == 1 && currentList[i].Initiate == true) {
          approvedSum += Number(currentList[i].Amount);
        }
      }

      if (approvedSum + inputAmount > totalAmount) {
        currentList[currentIndex].Amount =
          currentList[currentIndex].LastValidAmount;
        currentList[currentIndex].Percentage = (
          (currentList[currentIndex].LastValidAmount / totalAmount) *
          100
        )
          .toFixed(2)
          .replace(/\.00$/, "");

        toast.add({
          severity: "warn",
          summary: "Invalid Amount",
          detail: `Total amount cannot exceed ₹${totalAmount}. Approved so far: ₹${approvedSum}.`,
          life: 3000,
        });
        return;
      }

      // for (let i = 0; i < currentIndex; i++) {
      //   if (currentList[i].IsApproved == 1 && currentList[i].Initiate == true) {
      //     const approvedAmount = Number(currentList[i].Amount);
      //     if (inputAmount > approvedAmount) {
      //       currentList[currentIndex].Amount =
      //         currentList[currentIndex].LastValidAmount;
      //       currentList[currentIndex].Percentage = (
      //         (currentList[currentIndex].LastValidAmount / totalAmount) *
      //         100
      //       )
      //         .toFixed(2)
      //         .replace(/\.00$/, "");

      //       toast.add({
      //         severity: "warn",
      //         summary: "Invalid Amount",
      //         detail: `Amount cannot exceed ₹${approvedAmount} (approved in earlier line).`,
      //         life: 3000,
      //       });
      //       return;
      //     }
      //   }
      // }

      currentList[currentIndex].Amount = inputAmount;
      currentList[currentIndex].Percentage = ((inputAmount / totalAmount) * 100)
        .toFixed(2)
        .replace(/\.00$/, "");

      currentList[currentIndex].LastValidAmount = inputAmount;

      const totalPercentage = currentList.reduce(
        (total, item) => total + Number(item.Percentage),
        0
      );

      let remainingPercentage = 100 - totalPercentage;
      const otherItemsCount = currentList.length - 1;

      const adjustPercentageForItem = (index, percentageToAdd) => {
        if (index < currentList.length) {
          const item = currentList[index];
          item.Percentage = Number(item.Percentage) + percentageToAdd;
          item.Amount = ((Number(item.Percentage) / 100) * totalAmount)
            .toFixed(2)
            .replace(/\.00$/, "");
          item.Percentage = Number(item.Percentage)
            .toFixed(2)
            .replace(/\.00$/, "");
        }
      };

      if (remainingPercentage > 0) {
        let nextIndex =
          currentIndex === otherItemsCount
            ? currentList.findIndex((item) => item.Status === 0)
            : currentList.findIndex(
                (item, idx) => idx > currentIndex && item.Status === 0
              );
        if (nextIndex !== -1) {
          adjustPercentageForItem(nextIndex, remainingPercentage);
        }
      } else if (remainingPercentage < 0) {
        let nextIndex = (currentIndex + 1) % currentList.length;
        while (remainingPercentage < 0) {
          const item = currentList[nextIndex];
          if (item.Status === 0 && Number(item.Percentage) > 0) {
            if (Number(item.Percentage) >= Math.abs(remainingPercentage)) {
              adjustPercentageForItem(nextIndex, remainingPercentage);
              remainingPercentage = 0;
            } else {
              remainingPercentage += Number(item.Percentage);
              item.Percentage = 0;
              item.Amount = 0;
            }
          }
          nextIndex = (nextIndex + 1) % currentList.length;
        }
      }
    };

    const validatePercentage = (Percentage, Id, TableIndex) => {
      debugger;
      const currentList = TabArray.value[TableIndex].List;
      const currentIndex = currentList.findIndex((row) => row.Id === Id);
      const totalAmount = Number(details.value.Price);
      const inputPercentage = Number(Percentage);
      const inputAmount = (inputPercentage / 100) * totalAmount;

      let approvedSum = 0;
      for (let i = 0; i < currentIndex; i++) {
        if (currentList[i].IsApproved == 1 && currentList[i].Initiate == true) {
          approvedSum += Number(currentList[i].Percentage);
        }
      }

      if (approvedSum + inputPercentage > 100) {
        currentList[currentIndex].Percentage =
          currentList[currentIndex].LastValidPercentage;
        currentList[currentIndex].Amount =
          currentList[currentIndex].LastValidAmount;

        toast.add({
          severity: "warn",
          summary: "Invalid Percentage",
          detail: `Total percentage cannot exceed 100%. Approved so far: ${approvedSum}%.`,
          life: 3000,
        });
        return;
      }

      // for (let i = 0; i < currentIndex; i++) {
      //   if (currentList[i].IsApproved == 1 && currentList[i].Initiate == true) {
      //     const approvedPercentage = Number(currentList[i].Percentage);
      //     if (inputPercentage > approvedPercentage) {
      //       currentList[currentIndex].Percentage =
      //         currentList[currentIndex].LastValidPercentage;
      //       currentList[currentIndex].Amount =
      //         currentList[currentIndex].LastValidAmount;

      //       toast.add({
      //         severity: "warn",
      //         summary: "Invalid Percentage",
      //         detail: `Percentage cannot exceed ${approvedPercentage}% (approved in earlier row).`,
      //         life: 3000,
      //       });
      //       return;
      //     }
      //   }
      // }

      currentList[currentIndex].Percentage = inputPercentage
        .toFixed(2)
        .replace(/\.00$/, "");
      currentList[currentIndex].Amount = inputAmount
        .toFixed(2)
        .replace(/\.00$/, "");

      currentList[currentIndex].LastValidPercentage = inputPercentage;
      currentList[currentIndex].LastValidAmount = inputAmount;
      const totalPercentage = currentList.reduce(
        (total, item) => total + Number(item.Percentage),
        0
      );

      let remainingPercentage = 100 - totalPercentage;
      const otherItemsCount = currentList.length - 1;

      const adjustPercentageForItem = (index, percentageToAdd) => {
        if (index < currentList.length) {
          const item = currentList[index];
          item.Percentage = Number(item.Percentage) + percentageToAdd;
          item.Amount = ((Number(item.Percentage) / 100) * totalAmount)
            .toFixed(2)
            .replace(/\.00$/, "");
          item.Percentage = Number(item.Percentage)
            .toFixed(2)
            .replace(/\.00$/, "");
        }
      };

      if (remainingPercentage > 0) {
        let nextIndex =
          currentIndex === otherItemsCount
            ? currentList.findIndex((item) => item.Status === 0)
            : currentList.findIndex(
                (item, idx) => idx > currentIndex && item.Status === 0
              );

        if (nextIndex !== -1) {
          adjustPercentageForItem(nextIndex, remainingPercentage);
        }
      } else if (remainingPercentage < 0) {
        let nextIndex = (currentIndex + 1) % currentList.length;

        while (remainingPercentage < 0) {
          const item = currentList[nextIndex];
          if (item.Status === 0 && Number(item.Percentage) > 0) {
            if (Number(item.Percentage) >= Math.abs(remainingPercentage)) {
              adjustPercentageForItem(nextIndex, remainingPercentage);
              remainingPercentage = 0;
            } else {
              remainingPercentage += Number(item.Percentage);
              item.Percentage = 0;
              item.Amount = 0;
            }
          }
          nextIndex = (nextIndex + 1) % currentList.length;
        }
      }
    };

    function isOverdue(InitiatedAt) {
      if (!InitiatedAt) {
        console.error("InitiatedAt is empty or undefined.");
        return false;
      }

      let initiatedDate: any = parse(
        InitiatedAt,
        "dd MMM yyyy | hh:mm a",
        new Date()
      );

      if (isNaN(initiatedDate)) {
        console.error("Invalid date format for InitiatedAt:", InitiatedAt);
        return false;
      }

      const currentTime = new Date();
      return differenceInHours(currentTime, initiatedDate) > 24;
    }

    const CrystalReportPopup = ref(false);

    const ParameterValues = ref({
      Id: 0,
      BranchId: 0,
      HospitalId: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 14,
      HeaderTitle: "Purchase Order",
      ModuleId: 3,
    });

    function Print() {
      debugger;
      CrystalReportPopup.value = true;
      ParameterValues.value.Id = QueryStringValue.value.Id;
      ParameterValues.value.BranchId = QueryStringValue.value.BranchId;
      ParameterValues.value.HospitalId = HospitalId;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    return {
      validatePercentage,
      validateAmount,
      validatePaymentTermsPercentages,
      UpdatePayment,
      UndoPayment,
      EditFlag,
      EditPayment,
      grnreturndata,
      grnreturnvisible,
      grndata,
      grnvisible,
      POdata,
      POAvisible,
      POPaymentsvisible,
      RowClick,
      ViewDetails,
      fileuploadDelete,
      fileviewer,
      handleChangedocument,
      uploadedTableList,
      removeHtmlTags,
      getConvertedDate,
      getApprovaldata,
      ApprovalListchange,
      details,
      ApprovalList,
      ModelPopupDunction,
      cancelclose,
      Statuschange,
      datapass,
      handleClick,
      showpopModal: showmodalref,
      sidebardata,
      isActive,
      CopyPaymentList,
      item,
      items,
      activeIndex,
      currentStatus,
      next,
      prev,
      menu,
      toggle,
      Id,
      loading,
      SummaryName,
      UpdateApprovalStatus,
      approvaldetails,
      Approve,
      SuccessfullPopUp,
      ObjCancelPopUp,
      SaveCancelPO,
      RevertPO,
      AddItems,
      itemslist,
      QueryStringValue,
      // Add ObjVal1 and ObjVal5 to returned refs
      ObjVal1,
      ObjVal5,
      headers,
      loading1,
      List,
      GRNList,
      grnheaders,
      grnfilters,
      GRNReturnList,
      grnreturnheaders,
      PaymentList,
      paymentheaders,
      paymentfilters,
      TabArray,
      TabClick,
      InitiateOnClick,
      buttondisable,
      Approvalheaders,
      isOverdue,
      CreatePOAmendmentClick,
      Print,
      hidepopup,
      ParameterValues,
      PrintType,
      CrystalReportPopup,
    };
  },
});
</script>

<style lang="scss" scoped>
.col-xl-2 {
  width: 19.666667%;
}

.col-xl-10 {
  width: 80.333333%;
}

.sidebar-static-header {
  padding: 15px 15px 20px 45px;
  font-weight: 600;
  border-bottom: 5px solid #f8f9fe;
  position: sticky;
  left: 0px;
  top: 0px;
  background-color: #f8f9fe;
  z-index: 1;
}

.other-tabs {
  height: 90vh;
  padding-left: 5px !important;
  overflow: auto;
}

// .overall-bg {
//   section {
//     width: 100%;
//     overflow: hidden;
//   }
// }

.leftsidebar {
  position: relative;
  padding-right: 0px !important;
}

.back-btn {
  background-color: #0148e2;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  position: absolute;
  top: 20px;
  right: -12px;
  z-index: 1000;

  .back {
    width: 20px;
    position: absolute;
    top: -45px;
    left: 8px;
  }
}

.count-shows {
  font-weight: 300;
  padding-bottom: 10px;
}

.card-font {
  font-size: small;
}

.Actionsbtn {
  background-color: #4a8fe9 !important;
  border: none !important;
  padding: 8px !important;
}

.overall-bg {
  background-color: #f8f9fe;
  padding: 0;
  height: auto;
}

.header-top {
  margin-top: 0px !important;
}

.steps .p-tabview-header {
  width: 20% !important;
}

.steps .p-tabview-header-action {
  justify-content: center !important;
}

.Tabheading {
  font-size: small;
}

.summarycard {
  font-size: small !important;

  .termstxt {
    word-wrap: break-word;
  }
}

.p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: none !important;
}

.pi-check-circle {
  color: green;
  letter-spacing: 7px;
}

.sidebar-det-list {
  color: black !important;
}

.width80 {
  width: 80%;
}

@media only screen and (max-width: 1024px) {
  .width80 {
    width: 100%;
  }
}

.upload-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-button {
  background-color: #4caf50;
  /* Green color */
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.3s ease;
}

.upload-button:hover {
  background-color: #45a049;
  /* Darker green */
}

.upload-button i {
  font-size: 16px;
}

.action-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.upload-button {
  background-color: #0764a3;
  /* Green */
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.upload-button:hover {
  background-color: #45a049;
}

.initiate-button {
  background-color: #0764a3;
  /* Blue */
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.initiate-button:hover {
  background-color: #45a049;
  /* Darker Blue */
}

.upload-button i,
.initiate-button i {
  font-size: 16px;
}
</style>
